import { FileText } from "lucide-react";
import type React from "react";

export const EmptyState: React.FC = () => (
  <div className="py-12 text-center">
    <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-muted/50">
      <FileText className="h-12 w-12 text-muted-foreground" />
    </div>
    <h3 className="mb-2 font-semibold text-foreground text-lg">
      No invoices found
    </h3>
    <p className="mx-auto max-w-md text-muted-foreground text-sm">
      You don't have any invoices yet. Once you receive your first invoice, it
      will appear here.
    </p>
  </div>
);
